import styled from 'styled-components';
import { Card } from '@sainsburys-tech/luna-react';

export const StyledApplicationsLoader = styled((props: any) => (
  <Card {...props} />
))`
  height: 146px;
  position: relative;
  overflow: hidden;

  cursor: pointer;
  transition: all var(--ds-modifier-transition-duration);
`;
